import { Space, Spin, Typography } from 'antd';

const { Text } = Typography;

/**
 * Componente: Renderiza un título para pestañas (Tabs), con la opción de mostrar un contador y un indicador de carga (Spin).
 * 
 * @param {object} props
 * @param {string} props.title Texto principal del tab.
 * @param {number} [props.count] Número a mostrar entre paréntesis. Si no se proporciona, no se mostrará el contador.
 * @param {boolean} [props.loading=false] Indica si se muestra el indicador de carga.
 * Si se proporciona `count`, el spinner se muestra sobre el número, de lo contrario, se muestra junto al título.
 */
export const TabLabel = ({ title, count, loading = false }) => {
  const showCount = count !== null && count !== undefined;

  return (
    <Space size='small'>
      <Text style={{ color: 'inherit' }}>{title}</Text>
      <Spin size='small' spinning={loading}>
        {(showCount && !loading) ? <Text style={{ color: 'inherit', opacity: 0.7 }}>({count})</Text> : undefined}
      </Spin>
    </Space>
  );
};